module.exports = __webpack_public_path__ + "static/media/email_sent.08efd8ea.svg";